import React from 'react'
import '../App.css';
import Ebook from '../common/Ebook';


class ShowBooks extends React.Component {
    
    state = {

    };

    styles = {
        fontSize: 20,
        fontWeight: "bold",
        borderWidth: 20,
    }

    

    /*constructor(){
        super();
        this.handleIncrement = this.handleIncrement.bind(this);
    }*/

    render() {

        return(
            <div style={this.bookArrangement}>
                {
                    this.props.bookArray.map((item,index) =>(
                    <div style={{margin: 7}} key = {index}>
                        <Ebook
                            id={item.id}
                            title={item.title} 
                            category={item.category}
                            publisher={item.publisher}
                            image={item.image}
                            libraryProps={this.props.libraryProps}
                        />
                    </div>
                    ))
                }
                </div>
        )
        
    }


    //Styles
    closeBtn = {
        fontSize: 20,
        padding: 10,
        margin: 'auto'
    }

    selection = {
        color: 'black',
        padding: '15px 25px 15px 0px',
        display: 'inline-block',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 650,
    }

    categoryName = 
    {
        fontSize: '18px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: 0,
        margin: 0,
    }
    
    titlePageContainer =
    {
        height: 116,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    }

    bookArrangement =
    {
        display: 'flex',
        flexWrap: 'wrap',
        whiteSpace: 'nowrap',
        justifyContent: 'center',
    }

    searchButton =
    {
        height: '100%',
        borderRadius: '0 4px 4px 0',
        border: '1px solid grey',
        backgroundColor: 'light-grey',
        padding: 11,
        fontWeight: 500,
        fontSize: 15,
    }
        
    searchIcon = 
    {
        height: '2.5em',
        width: '2.5em',
        filter: 'brightness(0) invert(1)',
    }
    inputDiv =
    {
        display: 'flex',
        flexDirection: 'row',
        padding: '0 20px',
    }
    input=
    {
        fontSize: 15,
        height: '2.5em',
        width: '100%',
        borderRadius: '4px 0px 0px 4px',
        border: '1px solid grey',
        padding: '1px 10px',
    }
}

export default ShowBooks